export const METHOD = {
    get: 'get',
    post: 'post',
    put: 'put',
    del: 'delete',
  }
  
  export const mainApiPath = {
    store: 'kiosk/store',
    menu: 'kiosk/home',
    facilities: 'kiosk/facility',
    event: 'kiosk/event',
    promotion: 'kiosk/promotion',
    foodcourt_store: 'foodcourt/home',
    foodcourt_details: 'foodcourt/store',
    restaurant: 'restaurant/home',
    restaurant_details: 'restaurant/store',
    codeList: 'code/list',
    mallEnvironment: 'crowdednessoapm/getInfo'
  } 
